import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:hallo@mail-proxy.eu" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Contact me!"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-arrow-right" })
], -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.container)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.title)
    }, [
      _createElementVNode("span", {
        class: _normalizeClass([_ctx.$style.letter])
      }, "T", 2),
      _createElementVNode("span", {
        class: _normalizeClass([_ctx.$style.letter])
      }, "O", 2),
      _createElementVNode("span", {
        class: _normalizeClass([_ctx.$style.letter])
      }, "M", 2),
      _createElementVNode("span", {
        class: _normalizeClass([_ctx.$style.letter, _ctx.$style.dot])
      }, ".", 2),
      _createElementVNode("span", {
        class: _normalizeClass([_ctx.$style.letter])
      }, "S", 2),
      _createElementVNode("span", {
        class: _normalizeClass([_ctx.$style.letter])
      }, "T", 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.uTitle)
    }, "Biohacking Software Development", 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.mail)
    }, _hoisted_2, 2)
  ], 2))
}